/**
 * Created by Alex Aguilar on 8/26/2016.
 */
(function(){
    'use strict';

    var scheduleGrid = {
        template: '<div id="scheduler" class="mt-1"></div>',
        controller: scheduleGridController,
        controllerAs: 'vm',
        bindings:{
            appointments: '=',
            start: '=',
            end: '='
        }
    };

    angular
        .module('completeAir')
        .component('scheduleGrid', scheduleGrid);

    scheduleGridController.$inject = ['$translate', '$element', '$timeout', '$stateParams']

    function scheduleGridController($translate, $element, $timeout, $stateParams){
        var vm = this;
        var eleJQ = $element.find("div#scheduler");
        var dateParam = $stateParams.date;

        vm.$onInit = function(){
            var steps = onSteps(vm.start, vm.end);
            eleJQ.schedulerjs({
                'list': vm.appointments,
                'steps': steps,
                'pixelsPerHour': 60,
                'headName': $translate.instant('air.adminFlight.table.modelAircraft')
            });

            $timeout(function(){
                var jQHover = $('.sjs-grid-overlay-col-title'),
                    title = $translate.instant('air.adminFlight.titleInfoFlight');

                jQHover.webuiPopover({
                    animation: 'fade',
                    placement : 'auto',
                    trigger: 'hover',
                    title : title,
                    content: function(elementObject){
                        var eleParentJQ = elementObject.$element.parent(),
                            values = eleParentJQ.data('values');

                        var content = '<ul class="list-unstyled">' +
                            '<li>' +
                            '<span class="bold">'+ $translate.instant('air.adminFlight.numberFlight') +': </span> ' +
                            '<span>'+values.flightNumber+'</span></li>'+
                            '<li>' +
                            '<span class="bold">'+ $translate.instant('air.adminFlight.departureTime') +': </span> ' +
                            '<span>'+values.start+'</span></li>'+
                            '<li>' +
                            '<span class="bold">'+ $translate.instant('air.adminFlight.arrivalTime') +': </span> ' +
                            '<span>'+values.end+'</span></li>'+
                            '<li>' +
                            '<span class="bold">'+ $translate.instant('air.adminFlight.route') +': </span> ' +
                            '<span>'+values.route+'</span></li>'+
                            '</ul>' +
                            '<hr class="mt-1 mb-1">'+
                            '<ul class="list-inline">' +
                            '<li>' +
                            '<a href="#!/adminFlight/'+values.flightId+'/edit/'+dateParam+'/edit" class="bold web-ui-popover-adminFlight" title="'+$translate.instant('global.edit')+'">' +
                            '<i class="fa fa-pencil-square-o"></i> '+ $translate.instant('global.edit') +
                            '</a>' +
                            '</li>'+
                            '<li>' +
                            '<a href="#!/adminFlight/'+values.flightId+'/edit/'+dateParam+'/delete" class="bold web-ui-popover-adminFlight" title="'+$translate.instant('global.delete')+'">' +
                            '<i class="fa fa-trash-o"></i> '+ $translate.instant('global.delete') +
                            '</a>' +
                            '</li>'+
                            '</ul>';
                        return content;
                    },
                    closeable:true,
                    onShow: function($element) {
                        $(".web-ui-popover-adminFlight").on("click", function(){
                            WebuiPopovers.hideAll();
                        });
                    }
                });

            }, 100);
        }
    }

    function onSteps(start, end){
        var steps = [];
        for(var i = (start-1); i <= (end+2); i++){
            var step = (i < 10) ? "0"+i : i;
            steps.push(step + ":" + "00")
        }
        return steps;
    }
})();
